module.exports = __webpack_public_path__ + "static/fonts/iconfont.c2fbf02.eot";